import React, { useEffect, useState } from 'react';
import { Link, useLocation } from "react-router-dom";

const AppHeader = () => {

  const [links, setLinks] = useState(null)

  useEffect(() => {
    setLinks([document.getElementById("logo"), document.getElementById("activities-link"), document.getElementById("about-link"), document.getElementById("contact-link")])
  }, [])

  let location = useLocation();

  const getHeight = () => {
    
    switch (location.pathname) {
      case "/":
        return '70vh';
  
      default:
        return '45vh';
    }
  }

  const setActive = event => {
    if(links) {
      
      links.forEach(
        element => {element.className=""}
      ) 

    }

    event.target.parentElement.className="active-link"
  }

  return (
    <header id="App-Header" style={{height:getHeight()}}>
        
      <nav id="logo"
        onClick={ (event) => {setActive(event)} }
      >
        <Link to="/">Kisújszállási<br/>Városgazdálkodási<br/>Nonprofit Kft.</Link>
      </nav>

      <nav>
        <ul id="links">
          <li id="activities-link" onClick={ (event) => {setActive(event)} }> <Link to="/tevekenysegek">Tevékenységek</Link> </li>
          <li id="about-link" onClick={ (event) => {setActive(event)} }> <Link to="/rolunk">Rólunk</Link> </li>
          <li id="contact-link" onClick={ (event) => {setActive(event)} }> <Link to="/kapcsolat">Kapcsolat</Link> </li>
        </ul>
      </nav>

    </header>
  );
};

export default AppHeader;